<template>
  <div>
    <b-card title="Le richieste dei dipendenti" class="mt-5">
      <b-row class="mb-3">
        <b-col>
          <p>L'elenco dei ticket aperti dai tuoi dipendenti.</p>
        </b-col>
        <b-col class="text-right">
          <download-excel :data="tickets_export" class="btn btn-outline-danger">
            <i class="fas fa-file-download mr-2"></i> Export Elenco
          </download-excel>
        </b-col>
      </b-row>


      <b-table striped hover :items="tickets" :fields="fields">
        <template slot="user" slot-scope="data">
          <strong>{{ data.value.full_name }}</strong><br>
          <small class="text-secondary">{{ data.value.phone_number }} / {{ data.value.email }}</small>
        </template>
        <template slot="category" slot-scope="data">
          <strong>{{ data.value }}</strong>
        </template>
        <template slot="subcategory" slot-scope="data">
          <strong>{{ data.value }}</strong><br>
          <span class="font-size-12" v-if="data.item.tickets_extra">
            Prodotto di interesse:
            {{ data.item.tickets_extra.extra.product | capitalize | placeholder('-') }}
          </span>
        </template>
        <template slot="slot" slot-scope="data" tdClass="text-size-11" class="text-secondary">
          {{ data.value.start | moment('DD/MM/YYYY HH:mm') }}
        </template>
        <template slot="created_at" slot-scope="data" class="text-secondary">
          {{ data.value | moment('DD/MM/YYYY HH:mm') }}
        </template>
        <template slot="closed_at" slot-scope="data" class="text-secondary">
          {{ data.value | moment('DD/MM/YYYY HH:mm') | placeholder('-') }}
        </template>
        <template slot="managed_at" slot-scope="data" class="text-secondary">
          {{ data.value | moment('DD/MM/YYYY HH:mm') | placeholder('-') }}
        </template>
        <template slot="sla" slot-scope="data" class="text-secondary">
          KPI1: <strong>{{ data.value.sla_1 }}</strong><br>
          KPI2: <strong>{{ data.value.sla_2 }}</strong>
        </template>
      </b-table>


      <p v-if="!tickets.length" class="text-center p3">
        Non risultano richieste aperte associate al tuo account.<br>
      </p>

    </b-card>

    <transition name="fade">
      <Schedule/>
    </transition>

  </div>
</template>

<script>
  import EventBus from '@/services/eventbus';
  import Schedule from '@/components/plans/Schedule';
  import CreateTicket from './CreateTicket';
  import moment from 'moment';

  export default {
    name: 'Richieste',
    components: {
      Schedule, CreateTicket,
    },
    props: {
      create: {
        type: Boolean,
        required: false,
        default: false,
      },
    },
    data: () => ({
      tickets: [],
      ticketToEdit: null,
      fields: [
        {
          key: 'user',
          label: 'Dipendente',
          sortable: true,
        },
        {
          key: 'status',
          label: 'Stato',
          sortable: true,
        },
        {
          key: 'activity',
          label: 'Attività',
          sortable: true,
        },
        {
          key: 'slot',
          label: 'Appuntamento',
          sortable: true,
        },
        {
          key: 'created_at',
          label: 'Creato',
          sortable: true,
        },
        {
          key: 'managed_at',
          label: 'Preso in carico',
          sortable: true,
        },
        {
          key: 'closed_at',
          label: 'Chiuso',
          sortable: true,
        },
        {
          key: 'sla',
          label: 'SLA',
          sortable: true,
        },
      ],
    }),

    computed: {
      tickets_export() {
        return this.tickets.map(t => ({
          num: t.num,
          dipendente_nome: t.user.full_name,
          dipendente_mail: t.user.email,
          dipendente_phone: t.user.phone_number,
          dispositivo: (t.device && t.device.os_name) || '-',
          attivita: t.activity,
          stato: t.status,
          esito: t.resolution,
          creazione: moment(t.created_at).format('LLL'),
          appuntamento: moment(t.slot.start).format('LLL'),
          gestione: (t.managed_at && moment(t.managed_at).format('LLL')) || '-',
          chiusura: (t.closed_at && moment(t.closed_at).format('LLL')) || '-',
          sla_1: t.sla.sla_1,
          tempo_sla_1: t.sla.duration_sla_1,
          sla_2: t.sla.sla_2,
          tempo_sla_2: t.sla.duration_sla_2,
        }));
      },
    },

    mounted() {
      this.getData();
      EventBus.$on('refresh_data', this.getData);
    },

    methods: {
      async getData() {
        this.tickets = await this.$apiclient.getCustomerTickets();
      },

      createTicket() {
        this.create = true;
        this.ticketToEdit = null;
      },

      onTicketCreated() {
        this.create = false;
        this.getData();
      },
    },
  };

</script>

<style>
  .btn {
    border-radius: 0.6rem;
  }

  .card {
    box-shadow: 0 3px 20px rgba(0, 0, 0, 0.1);
  }

  .fc-right h2 {
    font-size: 18px;
  }
</style>



// WEBPACK FOOTER //
// src/pages/AreaRiservata/Tickets.vue